import { SearchState } from 'src/app/interfaces/search.interface';
import { SocialInitiativePostsShared } from './social-initiative-posts-shared.abstract';
import { defineCallParams } from './social-initiative.helpers';

export abstract class SocialInitiativePostsEntities extends SocialInitiativePostsShared {
  public fetchPersonalSpecificEntities(userId: string, state: SearchState): void {
    const paginationRelatedParams: number[] = defineCallParams(null, state);
    this.fetchUserSpecificEntities(userId, ...paginationRelatedParams);
  }

  public fetchEntityRelatedItems(entityId: string, state?: SearchState): void {
    const params: number[] = defineCallParams(null, state);
    this.fetchEntityRelatedItemsResolver(entityId, ...params);
  }

  protected abstract fetchUserSpecificEntities(userId: string, offset?: number, limit?: number): void;
  protected abstract fetchEntityRelatedItemsResolver(entityId: string, offset?: number, limit?: number): void;
}
